import { Clustered, type ClusteredProps } from './Layouts/Clustered/Clustered.client';
import type { ListItemsProps } from './Layouts/ListItems/ListItems.client';
import { ListItems } from './Layouts/ListItems/ListItems.client';

export type APlusProps =
  | ({
      /** the layout variant to render, either 'ListItems' or 'Clustered' */
      layout: 'ListItems';
    } & ListItemsProps)
  | ({
      /** the layout variant to render, either 'ListItems' or 'Clustered' */
      layout: 'Clustered';
    } & ClusteredProps);

/**
 * Renders the APlus module using the selected layout variant.
 */
export const APlus = (props: APlusProps) => {
  if (props.layout === 'ListItems') {
    return <ListItems {...props} />;
  }
  if (props.layout === 'Clustered') {
    return <Clustered {...props} />;
  }
  return null;
};
